import React from "react"
export const SelectColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column
  return (
    <select
      id="custom-select"
      className="form-select"
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      <option value="accident">Accident</option>
      <option value="blockage">Blockage</option>
      <option value="near-miss">Near Miss</option>
    </select>
  )
}
